<template>
  <Page>
    <template v-slot:page-header>
      <div class="container">
        <div class="page-header">
          <div class="title-container">
            <div class="title">
              <div class="header-container">
                <div class="title-header">สร้างตอนใหม่</div>
              </div>
            </div>
          </div>
          <div class="actions">
            <small class="text-danger mr-3"
              v-if="getServerError()">
              {{getServerError()}}
            </small>
            <span v-if="isSaving">
              <i class="fa fa-spin fa-spinner mr-1" />
              <small class="mr-2">
                กำลังบันทึก
              </small>
            </span>
            <button
              type="submit"
              class="btn btn-primary"
              :disabled="disableButton"
              @click.stop="onSubmit">
              บันทึก
            </button>
          </div>
        </div>
      </div>
    </template>
    <div class="container">
      <Tab>
        <div
          class="tab-item"
          v-for="(tabItem, tabIndex) in tabMenu"
          :key="tabIndex"
          :class="{'active': selectedTabIndex === tabIndex }"
          @click.stop="selectedTab(tabIndex)">
          {{tabItem.value}}
        </div>
      </Tab>
      <div
        class="tab-item tab-item-general"
        v-if="selectedTabIndex === 0">
        <div class="section-container">
          <SectionEpisodeInformation />
        </div>
        <div class="section-container">
          <SectionGallery />
        </div>
        <div class="section-container">
         <SectionAttachment />
        </div>
      </div>
      <div class="tab-item tab-item-general" v-if="selectedTabIndex === 1">
        <div class="section-container">
          <SectionContentImage
            @update:image="(payload) => $store.dispatch('setCurrentEpisode', payload)"
            :item="currentEpisode" />
        </div>
      </div>
    </div>
  </Page>
</template>

<script>
import _ from 'lodash';
import { mapState, mapActions } from 'vuex';
import { updateAttachmentById } from '@/attachment/api';
import Tab from '@/components/Tab.vue';
import SectionContentImage from '@/image/SectionContentImage.vue';
import SectionAttachment from '@/attachment/SectionAttachment.vue';
import Page from '@/layouts/Page.vue';
import errorFormatter from '@/utils/errorFormatter';
import SectionGallery from '@/gallery/SectionGallery.vue';

import SectionEpisodeInformation from './SectionEpisodeInformation.vue';

export default {
  mixins: [errorFormatter],
  components: {
    SectionEpisodeInformation,
    SectionGallery,
    SectionContentImage,
    SectionAttachment,
    Page,
    Tab,
  },
  data() {
    return {
      tabMenu: [
        {
          key: 'information',
          value: 'รายละเอียด',
        },
        {
          key: 'contentImage',
          value: 'รูปปก',
        },
      ],
      selectedTabIndex: 0,
    };
  },
  created() {
    this.$store.dispatch('initiateCurrentEpisode');
    this.$store.dispatch('resetAllGalleryState');
  },
  computed: {
    ...mapState({
      currentEpisode: (state) => state.episodeItem.currentEpisode,
      loadEpisodeState: (state) => state.episodeItem.loadEpisodeState,
      saveEpisodeState: (state) => state.episodeItem.saveEpisodeState,
      attachment: (state) => state.attachment.attachment,
      currentGallery: (state) => state.gallery.currentGallery,
    }),
    isProgramValid() {
      return this.currentEpisode.programId;
    },
    isEpisodeValid() {
      return this.currentEpisode.title;
    },
    haveErrorMessage() {
      return _.some(this.saveEpisodeState.error, (value) => value);
    },
    isSaving() {
      return this.saveEpisodeState.status === 'saving';
    },
    disableButton() {
      return this.haveErrorMessage || this.isSaving;
    },
    getAttachment() {
      return _.get(this.currentEpisode, 'attachment', null);
    },
    isContentCategoryValid() {
      if (this.episodeStatus !== 'draft') {
        return !!this.episodeContentCategory;
      }
      return true;
    },
  },
  methods: {
    ...mapActions(['inheritAttachment']),
    selectedTab(selectedTabIndex) {
      this.selectedTabIndex = selectedTabIndex;
    },
    async onSubmit() {
      if (this.currentEpisode.attachmentId) {
        const attachmentResponse = await updateAttachmentById(this.currentEpisode.attachmentId, this.attachment);
        this.inheritAttachment(attachmentResponse.data);
      }
      if (this.currentGallery.id) {
        this.currentEpisode.galleryId = this.currentGallery.id;
      }
      await this.$store.dispatch('createEpisode', { payload: this.currentEpisode });
      this.$router.push('/episodes');
    },
    getServerError() {
      return _.get(this.saveEpisodeState, 'error.serverError', null);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/components/section-container.scss';
</style>
